import React from "react";

import { Box, Typography, Button, Paper } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const AccesoDenegado = ({ onGoBack }) => {
  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: 420,
          width: '100%',
          textAlign: 'center',
          p: 5,
          borderRadius: 3,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            backgroundColor: 'error.lighter',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
          }}
        >
          <LockOutlinedIcon 
            sx={{ 
              fontSize: 40, 
              color: 'error.main' 
            }} 
          />
        </Box>

        <Typography 
          variant="h5" 
          fontWeight={600} 
          color="text.primary"
          gutterBottom
        >
          Acceso Denegado
        </Typography>

        <Typography 
          variant="body1" 
          color="text.secondary"
          sx={{ mb: 4 }}
        >
          No tienes los permisos necesarios para acceder a esta sección. 
          Contacta al administrador si crees que esto es un error.
        </Typography>

        {onGoBack && (
          <Button
            variant="contained"
            startIcon={<ArrowBackIcon />}
            onClick={onGoBack}
            sx={{
              textTransform: 'none',
              borderRadius: 2,
              px: 3,
              py: 1,
            }}
          >
            Volver al inicio
          </Button>
        )}
      </Paper>
    </Box>
  );
};

export default AccesoDenegado;

